<template>
  <div id="index" v-loading.fullscreen.lock="fullscreenLoading">
    <el-container height="800">
      <el-header style="height: 52px !important;position:relative;">
        <div class="logo-sty c-pointer" v-if="menuList != null && !menuNameSh" @click="goIndex">
          <img src="../assets/images/logo_fbt_01_v3.png" style="width: 184px; margin-top: 14px; margin-left: 24px" />
        </div>
        <div class="logo-sty" v-else @click="goHomePage">
          <img src="../assets/images/logo_fbt_01_v3.png" style="width: 184px; margin-top: 14px; margin-left: 24px" />
        </div>
        <div class="header-left" style="margin-left: 14px; margin-top: 4px" v-if="menuList != null && menuNameSh">
          <div class="header-left-top">
            <a class="el-icon-s-unfold font-S25 position-A m-l-15 mt3 c-pointer" style="margin-top: 14px"
              v-if="isCollapse" @click="isCollapse = false"></a>
            <a class="el-icon-s-fold font-S25 position-A m-l-15 mt3 c-pointer" style="margin-top: 14px" v-else
              @click="isCollapse = true"></a>
          </div>
        </div>
        <el-dropdown @command="platformJump" style="float: left" v-if="currentCenter">
          <div class="center">
            <img width=20 :src="currentCenter.iconUrl ? currentCenter.iconUrl : defaultPng" alt="" />
            {{ currentCenter.productName }}
            <img class="arrow-down" src="../assets/images/ic_arrow_down_grey_v2.png" alt="" srcset="">

          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="item in productsMenu" :key="item.productGuid" :command="item.productGuid">
              {{ item.productName }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <SwitchCompany></SwitchCompany>

        <el-dropdown @command="handleCommand" style="float: right">
          <i class="font-S25 fr mt3 mr15 c-pointer avatar-wrap" v-if="!logoutSh" @click="logoutSh = true">
            <img src="../assets/images/avatar.png" alt="" />
            <span style="font-size: 14px; font-style: normal">{{ staffNameAndPosition }}</span>
          </i>
          <i class="font-S25 fr mt3 mr15 c-pointer avatar-wrap" v-else @click="logoutSh = false">
            <img src="../assets/images/avatar.png" alt="" />
            <span style="font-size: 14px; font-style: normal">{{ staffNameAndPosition }}</span>
          </i>
          <el-dropdown-menu slot="dropdown" style="margin-right: 20px">
            <el-dropdown-item v-if="wechatUserNo" command="d">当前微信昵称：{{ wechatUserNo }}</el-dropdown-item>
            <el-dropdown-item command="e">当前版本：{{currentVersion}}</el-dropdown-item>
            <el-dropdown-item command="c">查看历史版本</el-dropdown-item>
            <el-dropdown-item command="a">修改密码</el-dropdown-item>
            <el-dropdown-item command="b">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-header>



      <el-container>
        <el-aside v-if="menuList != null && menuNameSh" :style="height">
          <el-menu :default-active="defaultActive" :default-openeds="defaultOpeneds" class="el-menu-vertical-demo"
            @open="handleOpen" @close="handleClose" @select="handleSelect" :collapse="isCollapse" :router="false">
            <template v-for="(item, ind) in menuList">
              <el-menu-item :index="item.path" v-if="item.children == null">
                <img :src="item.icon" style="width: 16px; height: 16px; padding-right: 5px" />
                <span>{{ item.menuName }}</span>
              </el-menu-item>
              <el-submenu :index="item.menuName" v-else>
                <template slot="title">
                  <img :src="item.icon" style="width: 16px; height: 16px; padding-right: 5px" />
                  <span>{{ item.menuName }}</span>
                </template>
                <el-menu-item-group>
                  <template v-for="child in item.children">
                    <el-menu-item :index="child.path">
                      <img :src="child.icon" style="width: 16px; height: 16px; padding-right: 5px" />
                      <span slot="title">{{ child.menuName }}</span>
                      <img src="../assets/images/new_window.png" v-if="child.isNewWindow == 'Y'" class="window-tip"
                        @click="newWindow(child.path)" />
                    </el-menu-item>
                  </template>
                </el-menu-item-group>
              </el-submenu>
            </template>
          </el-menu>
        </el-aside>
        <el-container>
          <el-main id="el-main-upstream-settlement-management">
            <div :style="height">
              <div class="bread" v-if="menuList != null && menuNameSh">
                <div v-if="$route.fullPath != '/historyEditionList'">
                  <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>首页</el-breadcrumb-item>
                    <el-breadcrumb-item>{{ secondLevel }}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{ threeLevels }}</el-breadcrumb-item>
                  </el-breadcrumb>
                </div>
                <div v-else>
                  <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>首页</el-breadcrumb-item>
                    <el-breadcrumb-item>历史版本记录</el-breadcrumb-item>
                  </el-breadcrumb>
                </div>
              </div>
              <!-- keep-alive 双分支：labelAuditList 返回时保住环节 tab 选中态；互斥 v-if 保证存量页面行为不变。
                   内容页实际渲染载体在 Index 的嵌套 router-view，仅 App.vue 配 meta.keepAlive 不生效（ES 端同款结论） -->
              <keep-alive>
                <router-view v-if="$route.meta.keepAlive" />
              </keep-alive>
              <router-view v-if="!$route.meta.keepAlive" />
            </div>
          </el-main>
        </el-container>
      </el-container>
      <!-- <el-footer>COPYRIGHT © 2016-2024 京ICP备2024044205号 北京传世博润科技有限公司</el-footer> -->
    </el-container>
    <el-dialog :title="textTitle" :visible.sync="dialogFormVisible" width="550px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" :label-position="right"
        class="demo-ruleForm">
        <el-form-item label="旧密码:" prop="oldPwd">
          <el-input :type="passwordTypes.oldPwd" v-model="ruleForm.oldPwd" class="w100f" placeholder="请输入原密码">
            <i 
              slot="suffix" 
              v-if="passwordTypes.oldPwd == 'password' && ruleForm.oldPwd" 
              @click="togglePassword('oldPwd')"
            >
              <img style="width:15px; margin-right: 5px;" src="../assets/close_eye.png" alt="" srcset="">
            </i>
            <i 
              slot="suffix" 
              v-if="passwordTypes.oldPwd == 'text' && ruleForm.oldPwd" 
              @click="togglePassword('oldPwd')"
            >
              <img style="width:15px; margin-right: 5px;" src="../assets/open_eye.png" alt="" srcset="">
            </i>
          </el-input>
        </el-form-item>
        <el-form-item label="新密码:" prop="pwd">
          <el-input :type="passwordTypes.pwd" v-model="ruleForm.pwd" class="w100f" placeholder="8-16位,含大小写字母 数字 符号">
            <i
              slot="suffix" 
              v-if="passwordTypes.pwd === 'password' && ruleForm.pwd" 
              @click="togglePassword('pwd')"
            >
              <img style="width:15px; margin-right: 5px;" src="../assets/close_eye.png" alt="" srcset="">
            </i>
            <i 
              slot="suffix" 
              v-if="passwordTypes.pwd === 'text' && ruleForm.pwd" 
              @click="togglePassword('pwd')"
            >
              <img style="width:15px; margin-right: 5px;" src="../assets/open_eye.png" alt="" srcset="">
            </i>
          </el-input>
        </el-form-item>
        <el-form-item label="确认新密码:" prop="confirmPwd">
          <el-input :type="passwordTypes.confirmPwd" v-model="ruleForm.confirmPwd" class="w100f" placeholder="请与新密码填写一致">
            <i
              slot="suffix" 
              v-if="passwordTypes.confirmPwd === 'password' && ruleForm.confirmPwd" 
              @click="togglePassword('confirmPwd')"
            >
              <img style="width:15px; margin-right: 5px;" src="../assets/close_eye.png" alt="" srcset="">
            </i>
            <i 
              slot="suffix" 
              v-if="passwordTypes.confirmPwd === 'text' && ruleForm.confirmPwd" 
              @click="togglePassword('confirmPwd')"
            >
              <img style="width:15px; margin-right: 5px;" src="../assets/open_eye.png" alt="" srcset="">
            </i>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="medium" type="info" @click="getUpdatePwd('ruleForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import SwitchCompany from '@/components/SwitchCompany.vue';
import { getItemByKey } from '@/uilt/tool'
export default {
  components:{
    SwitchCompany
  },
  name: 'Index',
  data() {
    let userInfo =  JSON.parse(localStorage.getItem('userInfo') || '{}');
    return {
      passwordTypes: {
        oldPwd: 'password',
        pwd: 'password',
        confirmPwd: 'password',
      },
      wechatUserNo:null,
      currentVersion:'未知',
      defaultPng: require('../assets/icon3.png'),
      currentCenter: null,
      fullscreenLoading: false,
      productsMenu: [],
      defaultActive: '',
      mobileNo: userInfo.mobileNo ? userInfo.mobileNo.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') : '',
      staffNameAndPosition: userInfo.staffName + ' ' + (userInfo.positionNames ? userInfo.positionNames[0] : ''),
      selectMenu: '',
      isCollapse: false,
      logoutSh: false,
      activeIndex: '/userManagement',
      winHeight: window.innerHeight,
      height: {
        height: '',
      },
      defaultOpeneds: [],
      menuList: [],
      menuNameSh: true,
      secondLevel: '',
      threeLevels: '',
      tenantGuid: '',
      ruleForm: {
        oldPwd: '',
        pwd: '',
        userGuid: '',
        confirmPwd: '',
      },
      right: '',
      rules: {
        oldPwd: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
          { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' },
        ],
        pwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: this.validatePasswordRule, trigger: 'blur' },
        ],
        confirmPwd: [
          { required: true, message: '请输入确认新密码', trigger: 'blur' },
           { validator: this.validateConfirmPassword, trigger: 'blur' },
        ],
      },
      dialogFormVisible: false,
      textTitle: '修改密码',
    };
  },
  created() {
    this.initPage();
  },
  watch: {
    winHeight(val) {
      this.winHeight = val;
      this.height = this.winHeight - 50 + 'px';
    },
    $route(to, from) {
      const path = this.$route.path.split('/');
      if (this.$route.query.fUrl == 'portraitMap' || path.at(-1).indexOf('portrait') > -1) {
        return
      }
      localStorage.setItem('fromPath', from.path || '');
      // FOUR-2975：隐藏功能页不在菜单树（如平台保密协议签署页），匹配不到会残留上次选中菜单——
      // 定向映射到来源菜单"认证资质申请"，待办直达时高亮/面包屑正确
      const activePathMap = { '/platformProtocolSign': '/certInfoManage' };
      const activePath = activePathMap[to.path] || to.path;
      this.menuList.forEach((i) => {
        if (i.children != null && i.children != '') {
          i.children.forEach((j) => {
            if (activePath == j.path) {
              this.secondLevel = i.menuName;
              this.threeLevels = j.menuName;
              localStorage.setItem('secondLevel', this.secondLevel);
              localStorage.setItem('threeLevels', this.threeLevels);
              localStorage.setItem('selectPath', activePath);
              this.defaultActive = activePath;
            } else {
              this.secondLevel = localStorage.secondLevel;
              this.threeLevels = localStorage.threeLevels;
              this.defaultActive = localStorage.selectPath;
            }
          });
        } else {
          if (activePath == i.path) {
            this.secondLevel = i.menuName;
            this.threeLevels = '';
          }
        }
      });
      this.setTitle();
    },
  },
  mounted() {
    window.onresize = () => {
      return () => {
        this.winHeight = window.innerHeight;
      };
    };
    this.height.height = this.winHeight - 50 + 'px';
  },
  methods: {
    togglePassword(field) {
      this.passwordTypes[field] = this.passwordTypes[field] === 'password' ? 'text' : 'password';
    },
    validatePasswordRule(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入新密码'));
        return;
      }
      
      const result = this.checkPassword(value);
      if (!result.isValid) {
        callback(new Error(result.firstUnmet));
      } else {
        callback();
      }
    },
    
    validateConfirmPassword(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入确认新密码'));
        return;
      }
      
      if (value !== this.ruleForm.pwd) {
        callback(new Error('两次输入的密码不一致'));
        return;
      }
      
      callback();
    },
    checkPassword(pwd) {
      if (!pwd) {
        return { 
          score: 0, 
          level: 'invalid', 
          checks: {}, 
          isValid: false, 
          firstUnmet: '请输入密码' 
        };
      }
      
      const checks = {
        length: pwd.length >= 8 && pwd.length <= 16,
        lower: /[a-z]/.test(pwd),
        upper: /[A-Z]/.test(pwd),
        number: /\d/.test(pwd),
        special: /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(pwd)
      };
      
      const passedCount = Object.values(checks).filter(Boolean).length;
      const isValid = passedCount === Object.keys(checks).length;
      
      const firstUnmet = this.findFirstUnmetRequirement(pwd, checks);
      
      return { 
        score: passedCount, 
        level: isValid ? 'strong' : 'weak', 
        checks, 
        firstUnmet, 
        isValid 
      };
    },
      
    findFirstUnmetRequirement(password, checks) {
      if (!password) return '请输入密码';
      
      const requirements = [
        { key: 'length', label: '密码长度必须为8-16位' },
        { key: 'lower', label: '必须包含小写字母' },
        { key: 'upper', label: '必须包含大写字母' },
        { key: 'number', label: '必须包含数字' },
        { key: 'special', label: '必须包含特殊符号' }
      ];
      
      for (const requirement of requirements) {
        if (!checks[requirement.key]) {
          return requirement.label;
        }
      }
      return null;
    },
    initPage() {
      const path = this.$route.path.split('/');
      if (this.$route.query.fUrl == 'portraitMap' || path.at(-1).indexOf('portrait') > -1) {
        return
      }
      if (!localStorage.token) return;
      if (this.$route.query.productGuid) {
        localStorage.productGuid = this.$route.query.productGuid;
      }

      this.getCurrentuser();
      this.getCurrentstaff();
      this.getOrgAndProduct();
      this.setTitle();
      this.getNickName();
      if (localStorage.productGuid) {
        this.getMenuList();
      } else {
        this.menuList = JSON.parse(localStorage.getItem('menuList'));
        // FOUR-2975：隐藏功能页定向映射到来源菜单（同 $route watch 处），防高亮残留
        const activePathMap = { '/platformProtocolSign': '/certInfoManage' };
        const activePath = activePathMap[this.$route.path] || this.$route.path;
        this.menuList.forEach((i) => {
          if (i.children != null && i.children != '') {
            i.children.forEach((j) => {
              if (activePath == j.path) {
                this.secondLevel = i.menuName;
                this.threeLevels = j.menuName;
                localStorage.setItem('secondLevel', this.secondLevel);
                localStorage.setItem('threeLevels', this.threeLevels);
                localStorage.setItem('selectPath', activePath);
                this.defaultActive = activePath;
              } else {
                this.secondLevel = localStorage.secondLevel;
                this.threeLevels = localStorage.threeLevels;
                this.defaultActive = localStorage.selectPath;
              }
            });
          } else {
            if (activePath == i.path) {
              this.secondLevel = i.menuName;
              this.threeLevels = '';
            }
          }
        });
      }
    },
    //获取微信昵称
    getNickName(){
      this.api.get('/ms-common-admin-platform-auth-service/user/data/get-webchat-user-no').then(res => {
        if (res.data.code == '00000') {
          this.wechatUserNo = res.data.data;
        }
      });
    },
    setTitle() {
      var promise = {
        guid:this.$route.query.productGuid||localStorage.productGuid,
      };
      if (!promise.guid) {
        document.title = 'FBT服务';
        return;
      }
      this.api.postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/product/data/get`, promise).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          document.title = (res.data.data.records && res.data.data.records[0].productName) || 'FBT服务';
        }
      });
    },
    handleCommand(res) {
      if (res == 'a') {
        //修改密码
        this.updatePwd();
      }
      if (res == 'b') {
        //退出登陆
        this.logout();
      }
      if (res == 'c') {
        this.$router.push('/historyEditionList');
      }
      if (res == 'd') {
        this.$confirm('已绑定微信：'+this.wechatUserNo, '微信绑定', {
          confirmButtonText: '解除绑定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.api.put('/ms-common-admin-platform-auth-service/user/data/unbind-webchat-user').then(res => {
              if (res.data.code == '00000') {
                this.wechatUserNo = null;
                this.$message.success('解除绑定成功');
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
      }
    },
    goIndex() {
      // this.$router.push('/reportQueryList-0');
      location.replace('/reportQueryList-0');
    },
    goHomePage(){
      let list=JSON.parse(localStorage.getItem('allMenuList'));
      let obj=getItemByKey('path','/SZ_homePageReportNew',list)
      console.log('str111',obj);
      if(obj){
        // this.$router.push(obj.path);
        window.open(  obj.path  );
      }
    },
    //
    updatePwd() {
      let self = this;
      self.dialogFormVisible = true;
      self.ruleForm.pwd = '';
      self.ruleForm.oldPwd = '';
      self.ruleForm.confirmPwd = '';
    },
    getUpdatePwd(formName) {
      let self = this;
      self.$refs[formName].validate((valid) => {
        if (valid) {
          if (self.ruleForm.pwd != self.ruleForm.confirmPwd) {
            self.$message.error('新密码与确认密码不一致，请重新输入！');
            return;
          }
          let pwd = self.$md5(self.ruleForm.pwd);
          let oldPwd = self.$md5(self.ruleForm.oldPwd);
          let promise = `pwd=` + pwd + `&oldPwd=` + oldPwd + `&userGuid=` + self.ruleForm.userGuid;
          const userInfo = JSON.parse(localStorage.userInfo);
          const logonUser = userInfo.logonUser;
          const params = {
            pwd: pwd,
            oldPwd: oldPwd,
            userGuid: self.ruleForm.userGuid
          }
          self.api.postJson('/ms-common-admin-platform-auth-service/user/data/updatePwd', params).then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.dialogFormVisible = false;
                self.$message.success('修改密码成功');
              } else {
                self.$message.error(res.data.msg);
              }
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //获取当前人信息
    getCurrentstaff() {
      let self = this;
      let tenantGuid = self.$store.state.guid;
      self.api
        .get(`/${serverConfig.msPersonnelService}/staff/data/get-currentstaff?` + `tenantGuid=` + tenantGuid)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.ruleForm.userGuid = res.data.data.userGuid;
            self.$store.commit('$_setUserId', res.data.data.userGuid);
            localStorage.setItem('userInfo', JSON.stringify(res.data.data));
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //获取当前中心下菜单
    getMenuList() {
      let self = this;
      let tenantGuid = self.$store.state.guid;
      self.api
        .get(
          `/${serverConfig.msCommonAdminPlatformAuthService}/menu/data/get-menu-by-currentuser?` +
          `appType=01&tenantGuid=` +
          tenantGuid +
          `&appSideIdentifier=scm_operative&productGuid=` +
          localStorage.productGuid,
        )
        .then((res) => {
          self.menuList = res.data.data;
          if (res.data.data[0].menuName == '主页') {
            //有个人首页，导航不显示个人主页菜单，直接跳转
            self.menuList = self.menuList.slice(1);
          }
          localStorage.setItem('menuList', JSON.stringify(self.menuList));
          self.menuList.forEach(function (i, idx) {
            if (i.externalLinkMark == '01') {
              i.src = i.path;
              i.path = '/reportQueryList-' + idx;
              console.log('1', i.externalLinkMark);
              if (i.children != null && i.children != '') {
                i.children.forEach(function (j, index) {
                  index = index + 1;
                  if (j.externalLinkMark == '01') {
                    console.log('11', j.externalLinkMark);
                    j.src = j.path;
                    j.path = '/reportQuery-' + idx + index
                  }
                });
              }
            }
          });
          localStorage.setItem('menuList', JSON.stringify(self.menuList));
          // FOUR-2975：隐藏功能页定向映射到来源菜单（同 $route watch 处）——待办新开标签走本接口分支，
          // 此处漏映射会导致签署页高亮残留为 localStorage.selectPath
          const activePathMap = { '/platformProtocolSign': '/certInfoManage' };
          const activePath = activePathMap[this.$route.path] || this.$route.path;
          this.menuList.forEach((i) => {
            if (i.children != null && i.children != '') {
              i.children.forEach((j) => {
                if (activePath == j.path) {
                  this.secondLevel = i.menuName;
                  this.threeLevels = j.menuName;
                  localStorage.setItem('secondLevel', this.secondLevel);
                  localStorage.setItem('threeLevels', this.threeLevels);
                  localStorage.setItem('selectPath', activePath);
                  this.defaultActive = activePath;
                } else {
                  this.secondLevel = localStorage.secondLevel;
                  this.threeLevels = localStorage.threeLevels;
                  this.defaultActive = localStorage.selectPath;
                }
              });
            } else {
              if (activePath == i.path) {
                this.secondLevel = i.menuName;
                this.threeLevels = '';
              }
            }
          });
        });
    },

    //选择某个菜单
    handleSelect(key, keyPath) {
      this.selectMenu = key;
      let self = this;
      let productGuid = this.$route.query.productGuid || localStorage.productGuid ;
      if(!this.$route.query.productGuid && !localStorage.productGuid){
        this.$router.push(key);
        return
      }
      let reqUrl = `/${serverConfig.msCommonAdminPlatformAuthService}/menu/data/get-menu-by-currentuser?appType=01&tenantGuid=${localStorage.guid}&productGuid=${productGuid}&appSideIdentifier=scm_operative`;
      self.api.get(reqUrl).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let menuList = res.data.data;
          if (res.data.data[0].menuName == '主页') {
            //有个人首页，导航不显示个人主页菜单，直接跳转
            menuList = menuList.slice(1);
          }
          menuList.forEach(function (i, idx) {
            if (i.externalLinkMark == '01') {
              i.src = i.path;
              i.path = '/reportQueryList-' + idx;
              console.log('1', i.externalLinkMark);
              if (i.children != null && i.children != '') {
                i.children.forEach(function (j, index) {
                  index = index + 1;
                  if (j.externalLinkMark == '01') {
                    console.log('11', j.externalLinkMark);
                    j.src = j.path;
                    j.path = '/reportQuery-' + idx + index
                  }
                });
              }
            }
          });
          localStorage.setItem('menuList', JSON.stringify(self.menuList));
          if (productGuid) {
            this.$router.push(key + '?productGuid=' + productGuid);
          } else {
            this.$router.push(key);
          }

        } else {
          self.$message.error(res.data.msg);
        }
      });

    },
    //登出
    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('guid');
      localStorage.removeItem('userId');
      localStorage.removeItem('menuList');
      localStorage.removeItem('userInfo');
      localStorage.removeItem('productGuid');
      this.$router.replace('/login');
      return;
      if (location.href.indexOf('https://scm-operation.csyaoly.com') > -1 || location.href.indexOf('https://scm-operation.cs4pl.com') > -1) {
        location.replace('https://www.cs4pl.com/operationLogin');
      } else if (location.href.indexOf('https://scm-operation-test.csbr.cn') > -1) {
        // location.replace('https://test.cs4pl.com/operationLogin');
        this.$router.replace('/login');
      } else {
        this.$router.replace('/login');
      }
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    newWindow(path) {
      const { href } = this.$router.resolve(path);
      window.open(href, '_blank');
    },
    //切换平台
    platformJump(productGuid) {
      let self = this;
      let reqUrl = `/${serverConfig.msCommonAdminPlatformAuthService}/menu/data/get-menu-by-currentuser?appType=01&tenantGuid=${localStorage.guid}&productGuid=${productGuid}&appSideIdentifier=scm_operative`;
      self.api.get(reqUrl).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let menuList = res.data.data;
          if (res.data.data[0].menuName == '主页') {
            //有个人首页，导航不显示个人主页菜单，直接跳转
            menuList = menuList.slice(1);
          }
          menuList.forEach(function (i, idx) {
            if (i.externalLinkMark == '01') {
              i.src = i.path;
              i.path = '/reportQueryList-' + idx;
              console.log('1', i.externalLinkMark);
              if (i.children != null && i.children != '') {
                i.children.forEach(function (j, index) {
                  index = index + 1;
                  if (j.externalLinkMark == '01') {
                    console.log('11', j.externalLinkMark);
                    j.src = j.path;
                    j.path = '/reportQuery-' + idx + index
                  }
                });
              }
            }
          });
          localStorage.setItem('menuList', JSON.stringify(self.menuList));
          if (menuList[0].children != null && menuList[0].children.length > 0) {
            setTimeout(function () {
              location.href = location.origin + menuList[0].children[0].path + '?productGuid=' + productGuid;
            }, 200)
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取当前登陆人的中心
    getOrgAndProduct() {
      this.api
        .get('/ms-personnel-service/staff-home/org-and-product?staffGuid=' + JSON.parse(localStorage.getItem('userInfo')).staffGuid)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.organisationName = res.data.data.organisationName;
            this.productsMenu = res.data.data.products;
            this.productsMenu.forEach((item) => {
              if (item.icon) {
                let obj = JSON.parse(item.icon);
                this.$set(item, 'iconUrl', obj.path);
              }
              if (item.productGuid == localStorage.productGuid) {
                this.currentCenter = item;
              }
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    //获取企业
    getCurrentuser() {
      let self = this;
      self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenants-by-currentuser`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (res.data.data != null && res.data.data != '') {
            this.currentVersion = res.data.data[0].systemVersion;
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
  },
};
</script>
<style >
.updatePwd-sty {
  right: 40px !important;
}

.logout-sty {
  right: 40px !important;
}

.avatar-wrap {
  display: flex;
  align-items: center;
  margin-top: 8px !important;
}

.avatar-wrap img {
  width: 30px;
  margin-top: 4px;
}

.avatar-wrap span {
  font-size: 14px;
  font-style: normal;
  margin-top: 6px;
  margin-left: 10px;
  margin-right: 20px;
}

/deep/ .el-header {
  height: 52px !important;
}

.el-menu-item-group__title {
  padding: 0px;
}

.el-menu--collapse {
  height: 100%;
}

.el-aside {
  overflow-y: auto;
  background-color: #4fa1a4 !important;
}

.el-container {
  background-color: #4fa1a4;
}

.el-menu {
  background-color: #32404f;
}

.el-menu-item {
  color: #fff;
  background-color: #32404f;
}

.logo-sty {
  background-color: #ffffff !important;
  cursor: pointer;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 230px !important;
  background: #32404f !important;
}

.el-menu-item:hover {
  outline: 0;
  background: linear-gradient(90deg, #4fa1a4 0%, #32404f 100%);
}

.el-menu-item:focus {
  outline: 0;
  background-color: #32404f;
}

.iframe {
  width: 100%;
}

.el-submenu__title {
  color: #fff;
  background-color: #32404f;
}

.el-submenu__title:hover {
  background-color: #32404f;
}

.el-menu-item.is-active {
  background: linear-gradient(90deg, #4fa1a4 0%, #32404f 100) !important;
}

.el-menu-item {
  position: relative;
}

.window-tip {
  width: 20px;
  height: 20px;
  position: absolute;
  z-index: 1000000;
  right: 15px;
  top: 15px;
}

.center {
  padding-top: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;

}

.center img {
  width: 20px;
  height: 20px;
  margin-right: 6px;
}

.center .arrow-down {
  width: 15px;
  height: auto;
}
</style>
